import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { applyTheme, LOGIN_CHANNEL, logoutClearSession, SessionKeys, UserIsLoggedIn } from '../utils/AppUtils';
import { setUserPremium, setUserRole, userDetailBroker } from '../redux/user/actions';
import { loginBroker, loginBrokerClear, loginClear } from '../redux/auth/actions';
import CONFIG from '../utils/config';
import $ from "jquery";
import axios from 'axios';
import API_LIST from '../utils/apiList';
import { myCart } from '../redux/Cart/actions';
import { fetchSubscribedData } from '../redux/checkout/actions';
import { getSmartBar, getSmartBarClear } from '../redux/home/actions';
import { useAuth } from '../utils/auth';
import SimplePopup from '../components/modal/SimplePopup';
import Loader from '../components/Loader/Loader';

const GoogleAuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authProvider = useAuth();

  const hash = window.location.hash;
  const params1 = new URLSearchParams(location.search);
  const error = params1.get('error');
  const auth = useSelector((state) => state.auth.auth);
  const authBroker = useSelector((state) => state.auth.authBroker);

  const [isLoadingLogin, setIsLoadingLogin] = useState(false);
  const [authData, setAuthData] = useState(null);
  let redirectPath = "/home";
  const [confirmModal, setConfirmModal] = useState(false);
  const [showModalMsg, setShowModalMsg] = useState("");
  

  useEffect(() => {

    if (hash) {

      const params = new URLSearchParams(hash.substring(1));
      // Get the access_token from the hash
      const accessToken = params.get('access_token');
      if (accessToken) {
        setAuthData(accessToken);
        setIsLoadingLogin(true);
        dispatch(
          loginBroker({
            action: "realtor_login_google",
            access_token: accessToken
          })
        );
      }else{
        setShowModalMsg("Error in login.");
        setConfirmModal(true)
        navigate("/");
      }
    }
  }, [hash]);



  useEffect(() => {
    console.log(authBroker);
    if (!_.isEmpty(authBroker)) {
      setIsLoadingLogin(false);
    }
    if (
      localStorage.getItem(SessionKeys.API_TOKEN_BROKER) !== null &&
      localStorage.getItem(SessionKeys.API_TOKEN_BROKER) !== "" &&
      localStorage.getItem(SessionKeys.API_TOKEN_BROKER) !== undefined
    ) {
      console.log("inside authBroker", authBroker);
      if (authBroker.status === "success") {
        localStorage.removeItem(SessionKeys.LOGIN_COMPANY);
        // console.log('auth: ', auth.payload)

        dispatch(
          userDetailBroker({
            module: "getOrderDetailBroker",
            apiToken: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          })
        );
        LOGIN_CHANNEL.onmessage = (event) => {
          if (event.data && event.data?.login) {
            window.location.reload();
          }
        };
        UserIsLoggedIn();
        const roleArray = authBroker.payload.user.role;
        if (_.isArray(roleArray)) {
          // console.log("USER ROLE", roleArray);

          if (roleArray.includes("customer")) {
            dispatch(setUserRole("customer"));
          } else if (roleArray.includes("realtor")) {
            dispatch(setUserRole("realtor"));
          } else if (roleArray.includes("manager")) {
            dispatch(setUserRole("manager"));
          } else if (roleArray.includes("pmpro_membership_manager")) {
            // console.log("USER ROLE PMPRO", roleArray);
            dispatch(setUserRole("broker"));
            localStorage.setItem(
              SessionKeys.BROKER_ID,
              authBroker.payload.user.user_id
            ); // IT WILL BE DYNAMIC
          } else if (roleArray.includes("instructor")) {
            dispatch(setUserRole("instructor"));
          } else if (roleArray.includes("host")) {
            dispatch(setUserRole("host"));
          } else if (roleArray.includes("broker_admin")) {
            dispatch(setUserRole("admin"));
          }
        } else {
          logoutClearSession();
          setShowModalMsg("Invalid user role.");
          setConfirmModal(true)
          setIsLoadingLogin(false);
          dispatch(loginClear());
          dispatch(loginBrokerClear());
          navigate("/");
        }

        const colorElement1 = authBroker.payload.user.branding_primary_color_1;
        const colorElement2 = authBroker.payload.user.branding_primary_color_2;
        $("html").css(
          "--color-element-1",
          colorElement1 ? colorElement1 : CONFIG.COLOR_ELEMENT_1
        );
        $("html").css(
          "--color-element-2",
          colorElement2 ? colorElement2 : CONFIG.COLOR_ELEMENT_2
        );

        if (localStorage.getItem(SessionKeys.SESSION_ID)) {
          syncLocalCart();
          localStorage.removeItem(SessionKeys.SESSION_ID);
        }

        let cookieArray = document.cookie.split(";");
        let acceptedCookie = [];
        let cookieConsentDate = "";
        for (let cookie of cookieArray) {
          if (cookie.includes("cc_cookie")) {
            let cookieData = cookie.split("e=")[1];
            let cookieInfo = JSON.parse(decodeURIComponent(cookieData));
            acceptedCookie = cookieInfo.categories;
            cookieConsentDate = cookieInfo.consent_date;
          }
        }
        window.captureMyEvents("loginSuccessfull", {
          email: authBroker.payload.user.email,
          userId: authBroker.payload.user.user_id,
          ipAddress: authBroker.payload.user.ip_address,
          acceptedCookie,
          cookieConsentDate,
        });
        dispatch(
          myCart({
            module: "myCart",
            email: authBroker?.payload?.user?.email,
          })
        );

        if (authBroker.payload.user.isPremium === "1") {
          dispatch(setUserPremium(true));
        }

        // dispatch(
        //   getSubscriptionPlan({
        //     URL: `${CONFIG.API_URL_BROKER}/${API_LIST.ECOM_API.GET_SUBSCRIPTION_PLAN}`,
        //     payload: {},
        //     isJSON: true,
        //     method: "post",
        //   })
        // );

        dispatch(
          fetchSubscribedData({
            method: "POST",
            URL: `${CONFIG.API_URL_BROKER}${API_LIST.ECOM_API.GET_SUBSCRIBED_DATA}`,
            payload: {
              token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            },
            isJSON: true,
          })
        );

        if (authBroker.payload?.user?.config?.banner_strip !== "false") {
          dispatch(getSmartBarClear({}));
          dispatch(
            getSmartBar({
              module: "getSmartBar",
              postData: {
                token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
                  ? localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
                  : "",
              },
            })
          );
        }

        const branding = authBroker.payload.user.branding;

        if (authBroker.payload.user.apply_theme) {
          !_.isEmpty(branding) && applyTheme(branding);
        } else {
          if ($("body").hasClass("cus-bro-theme")) {
            $("body").removeClass("cus-bro-theme");
          }
        }
        // dispatchAPILiveCall();
        if (localStorage.getItem(SessionKeys.LOCATION_PATH_REDIRECT)) {
          const locationPath = JSON.parse(
            localStorage.getItem(SessionKeys.LOCATION_PATH_REDIRECT)
          );
          if (!_.isEmpty(locationPath)) {
            redirectPath = locationPath.path;
            if (locationPath.query) {
              redirectPath = redirectPath + "/" + locationPath.query;
            }

          }
        }
        setTimeout(() => {
          if (localStorage.getItem(SessionKeys.IS_AGGREED) === "true") {
            localStorage.removeItem(SessionKeys.LOCATION_PATH_REDIRECT);
            if (authBroker.payload.user.courseURL) {
              navigate(authBroker.payload.user.courseURL);
            } else {
              authProvider.login(authBroker);
              console.log("redir--1", redirectPath)
              navigate(redirectPath, { replace: true });
            }
            // navigate("/home");
          } else {
            navigate("/privacy-and-terms");
          }
        }, 500);
      } else if (authBroker?.status === "error") {
        // console.log('authBroker', auth?.error?.message, authBroker?.error?.message)
        window.captureMyEvents("googleloginFailed", {
          message: authBroker?.error?.message,
        });
        logoutClearSession();
        setShowModalMsg("Something went wrong.");
        setConfirmModal(true)
        setIsLoadingLogin(false);
        dispatch(loginClear());
        dispatch(loginBrokerClear());
        navigate("/");
      }
    }
    if (authBroker?.status === "error") {
      // console.log('authBroker', auth?.error?.message, authBroker?.error?.message)
      window.captureMyEvents("loginFailed", {
        message: authBroker?.error?.message,
      });
      logoutClearSession();
      setShowModalMsg("Error in login.");
      setConfirmModal(true)
      setIsLoadingLogin(false);
      dispatch(loginClear());
      dispatch(loginBrokerClear());
      navigate("/");
    }
  }, [auth, navigate, authBroker]);

  const syncLocalCart = async () => {
    await axios.post(
      `${CONFIG.API_URL_BROKER}${API_LIST.ECOM_API.SYNC_LOCAL_CART}`,
      {
        token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        session_id: localStorage.getItem(SessionKeys.SESSION_ID),
      }
    );
  };

  return (
    <>
    <Loader start={isLoadingLogin} />
      <div>
        {authData && false ? (
          <div>
            <h1>Welcome!</h1>
            <p>Authenticated successfully with Google.</p>
            <p>{authData}</p>
          </div>
        ) : (
          <p>Loading authentication details...</p>
        )}
      </div>
      <SimplePopup
        confirmModal={confirmModal}
        setConfirmModal={setConfirmModal}
        showModalMsg={showModalMsg}
        isRightIcon={false}
      />
    </>
  );
};

export default GoogleAuthCallback;
